import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

import { IdentifierValidationResponse } from "@/models/site-credentials/loyaltycard/IdentifierValidationResponse";

import { loyaltyCardService } from "@/services/site-credentials/loyaltycard/LoyaltyCardService";

import { Button } from "@/components/ui/button";
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import ErrorMessage from "@/components/error-message/error-message";
import useFooterDisplayMode from "@/hooks/useFooterDisplayMode";


export default function LoyaltyCardAssociationSuccess() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<IdentifierValidationResponse>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { displayMode, excludeAssetKey } = useFooterDisplayMode();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await loyaltyCardService.loyaltyCardSuccessAssociation(
        location.state != null ? location.state.nextStep : ""
      );
      if (response.kind === "success") {
        history.push(response.value.nextStep.substring(4), response.value);
      }
      if (response.kind === "error") {
        setError(t("common.unexpected_error"));
      }

      setLoading(false);
    } catch (e) {
      setError(t("common.unexpected_error"));
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-12 pb-2">
      <div className="justify-center">
        <Header
          title={t("loyalty_card_association_success.header_title")}
          subtitle={t("loyalty_card_association_success.header_message")}
          showLoading={loading}
        />
      </div>
      {displayMode !== "none" && (
        <div
          role="note"
          aria-label={t(displayMode === "carousel" ? "accessibility.signin.icons_carousel" : "accessibility.signin.icons")} className="flex flex-col">
          <Footer
            contextualInformationVisible
            displayMode={displayMode}
            excludeAssetKey={excludeAssetKey}
          />
        </div>
      )}
      <Button
        type="button"
        onClick={handleSubmit}
      >
        {t("loyalty_card_association_success.button_next_message")}
      </Button>
      <ErrorMessage errorString={error} />
      <div className="flex flex-col">
        <Footer displayMode="none" />
      </div>
    </div>
  );
}
